import React from 'react';
import classNames from 'classnames';
import { Stage } from '../Home';
import { PROCESS_CONFIG } from '../progressConfig';
import * as styles from './ProgressBarLegend.module.scss';
import { Inline } from 'components/layout';
import { Text } from 'components/core';

type ProgressBarLegendProps = {
  complete?: number;
  partiallyComplete: number;
  consensusRequired?: number;
  notStarted: number;
  stage: Stage;
};

const countSizeClass = (counts: Omit<ProgressBarLegendProps, 'stage'>) => {
  const maxCount = Math.max(
    counts?.complete ?? 0,
    counts?.partiallyComplete ?? 0
  );
  const numDigits = String(maxCount).length;

  switch (numDigits) {
    case 1:
      return 'xs';
    case 2:
      return 'sm';
    case 3:
      return 'md';
    case 4:
      return 'lg';
    case 5:
      return 'xl';
    case 6:
      return 'xxl';
    default:
      return 'xxl';
  }
};

export const ProgressBarLegend = ({
  stage,
  ...counts
}: ProgressBarLegendProps) => {
  const config = PROCESS_CONFIG[stage === 'included' ? 'included' : 'default'];
  const filteredConfig = [...config].filter(({ key }) => counts[key] != null);

  return (
    <ul className={styles.list}>
      {filteredConfig.map(({ key, label, variant }) => {
        return (
          <Inline
            component="li"
            alignX="left"
            spacing={3}
            key={key}
            className={styles.listItem}
          >
            <Text
              className={classNames({
                [styles.count]: true,
                [styles[countSizeClass(counts)]]:
                  key === 'complete' || key === 'partiallyComplete',
              })}
              component="span"
            >
              {counts[key]}
            </Text>
            <span className={classNames(styles.bullet, styles[variant])} />
            <Text size="md" variant="neutral" component="span">
              {label}
            </Text>
          </Inline>
        );
      })}
    </ul>
  );
};
